import { type ValueOf } from '@models/helpers/custom'

export const LocalizationRequestPendings = {
  GET_DEFAULT_LANGUAGE_TRANSLATIONS_PENDING: 'getDefaultLanguageTranslationsPending',
  GET_COUNTRIES_LANGUAGE_TRANSLATIONS_PENDING: 'getCountriesLanguageTranslationsPending'
} as const

export type LocalizationRequestPendingType = ValueOf<typeof LocalizationRequestPendings>
export type LocalizationRequestPendingsType = Record<LocalizationRequestPendingType, boolean>
